import {ParsedUrlQuery} from 'querystring'
import {useMemo} from 'react'

import {PageKey} from 'lib/constants'

import {pageToHref} from '../router'

/**
 * Create a string `href` for navigation.
 */
export default function useLink(
  key: PageKey,
  query: ParsedUrlQuery = {}
): string {
  return useMemo(() => pageToHref(key, query), [key, query])
}
